import { post } from "../request";

export const uploadLog = (data) => {
  return post("/ProxyAdmin/log/save", data);
};

export const uploadDiagnosisLog = (data) => {
  return post("/ProxyAdmin/log/save", [data], "json", {
    timeout: 60000,
  });
};
